import { render, staticRenderFns } from "./funnel-remote-select.vue?vue&type=template&id=5dd34832&scoped=true"
import script from "./funnel-remote-select.vue?vue&type=script&lang=js"
export * from "./funnel-remote-select.vue?vue&type=script&lang=js"
import style0 from "./funnel-remote-select.vue?vue&type=style&index=0&id=5dd34832&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dd34832",
  null
  
)

export default component.exports